export const nameFieldInputHandler = (
    input: string,
    setter: (input: string) => void
): void => {
    const doesntContainIllegalValues = /^[A-Za-z0-9æøåÆØÅ'\- ]*$/.test(input)
    if (doesntContainIllegalValues) {
        setter(input)
    }
}
